import * as React from 'react';
import { createSvg } from '../../utils/createSvg';
export var CloseSmall = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M13.78 12.72a.75.75 0 1 1-1.06 1.06L8 9.06l-4.72 4.72A.751.751 0 0 1 2.22 12.72L6.94 8 2.22 3.282A.75.75 0 1 1 3.28 2.22L8 6.94l4.72-4.72a.75.75 0 1 1 1.06 1.06L9.06 8l4.72 4.72Z" })), '0 0 16 16', 'CloseSmall');
//# sourceMappingURL=CloseSmall.js.map